"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ErrorListBuilder = function (errorList, setGraphQLErrors) {
    if (errorList.length === 1) {
        setGraphQLErrors(function (graphQLErrors) { return graphQLErrors.concat(errorList[0]); });
    }
    else {
        errorList.map(function (item) {
            setGraphQLErrors(function (graphQLErrors) { return graphQLErrors.concat(item); });
        });
    }
};
exports.default = ErrorListBuilder;
//# sourceMappingURL=ErrorListBuilder.js.map